/**
 * The member/flag/list response schema
 */

type Dictionary = { [key: string]: string };

enum MemberEligibilityFlagTypes {
  "low_income_subsidy",
  "end_stage_renal_disease",
  "transplant",
  "hospice",
  "cancer",
  "sickle_cell",
  "grace_period",
  "suspended_benefit",
}

export const MEMBER_ELIGIBILITY_FLAG_TYPE_LABELS: Dictionary = {
  "low_income_subsidy": "Low Income Subsidy",
  "end_stage_renal_disease": "End-Stage Renal Disease",
  "transplant": "Transplant",
  "hospice": "Hospice",
  "cancer": "Cancer",
  "sickle_cell": "Sickle Cell",
  "grace_period": "Grace Period",
  "suspended_benefit": "Suspended Benefit",
};

interface MemberEligibilityFlagListResult {
  readonly client_id: string;
  readonly created_at?: string;
  readonly effective_date: string;
  readonly end_date: string;
  readonly external_member_id: string;
  readonly flag_type: MemberEligibilityFlagTypes;
  readonly id: string;
  readonly low_income_subsidy_level?: string;
  readonly person_code: string;
  readonly rn?: string
  readonly start_date: string;
  readonly termination_date?: string;
  readonly update_record?: boolean
}

export interface MemberEligibilityFlag {
  flag: MemberEligibilityFlagListResult;
}

export interface MemberEligibilityFlagListResponse {
  readonly result_count: string;
  readonly results: ReadonlyArray<MemberEligibilityFlag>;
}
